import styled from '@emotion/styled';

const BigText =styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 19px;
  color: var(--black);
`

export default BigText;